/* Cash Money - Arabic governorate labels inside the COD order form.

   Problem: the order form is fully Arabic but the governorate dropdown
   renders English names (Cairo / Giza / Qalyubia...). That is the last
   step before an order is confirmed, and the easiest place for an Arabic
   customer to give up or pick the wrong governorate.

   SAFETY: only the visible option TEXT is changed. option.value is never
   touched (values stay SU / SHR / ALX ...), so exactly the same data is
   submitted to the app and to Shopify. Zero risk to shipping information.

   NOTE: deliberately no requestAnimationFrame here. rAF is paused while a
   tab is hidden, so a customer who opens the form in a background tab would
   still see English. Plain timers keep working.

   Stopgap until the app exposes Arabic governorate labels in its settings.
   If that is configured later, this file finds nothing to translate. */
(function(){
'use strict';
var M={
'6th of october':'السادس من أكتوبر',
'al sharqia':'الشرقية','sharqia':'الشرقية',
'alexandria':'الإسكندرية','aswan':'أسوان','asyut':'أسيوط',
'beheira':'البحيرة','beni suef':'بني سويف','cairo':'القاهرة',
'dakahlia':'الدقهلية','damietta':'دمياط',
'faiyum':'الفيوم','fayoum':'الفيوم',
'gharbia':'الغربية','giza':'الجيزة','helwan':'حلوان',
'ismailia':'الإسماعيلية',
'kafr el-sheikh':'كفر الشيخ','kafr el sheikh':'كفر الشيخ',
'luxor':'الأقصر','matrouh':'مطروح','matruh':'مطروح',
'minya':'المنيا','monufia':'المنوفية','menofia':'المنوفية',
'new valley':'الوادي الجديد','north sinai':'شمال سيناء',
'port said':'بورسعيد','qalyubia':'القليوبية','qena':'قنا',
'red sea':'البحر الأحمر','sohag':'سوهاج',
'south sinai':'جنوب سيناء','suez':'السويس'
};
var D='data-cm-ar';
function tr(s){
  if(!s||!s.options)return 0;
  var n=0;
  for(var i=0;i<s.options.length;i++){
    var o=s.options[i];
    if(o.hasAttribute(D))continue;
    var a=M[(o.textContent||'').trim().toLowerCase()];
    if(a){o.textContent=a;o.setAttribute(D,'1');n++;}
  }
  return n;
}
function scan(){
  var s=document.querySelectorAll('select'),n=0;
  for(var i=0;i<s.length;i++)n+=tr(s[i]);
  return n;
}
function retry(){
  var t=[0,120,400,900,1800,3000];
  for(var i=0;i<t.length;i++)setTimeout(scan,t[i]);
}
function boot(){
  scan();
  document.addEventListener('click',function(e){
    var el=e.target;
    if(el&&el.closest&&el.closest('#rsi_buy_now_button,[id*=rsi],[class*=rsi]'))retry();
  },true);
  if('MutationObserver' in window){
    var p=false;
    new MutationObserver(function(){
      if(p)return;p=true;
      setTimeout(function(){scan();p=false;},0);
    }).observe(document.body,{childList:true,subtree:true});
  }
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
else boot();
})();
